import type { PropsWithChildren } from 'react';

import { Navigate } from 'react-router';

import type { EFeatureFlags } from '@/shared/consts';
import { checkIsFlagEnabled } from '@/shared/helpers';

type Props = PropsWithChildren<{ flag: EFeatureFlags; urlToRedirect?: string }>;

export const FeatureFlagGuard = ({ flag, urlToRedirect = '..', children }: Props) =>
  checkIsFlagEnabled(flag) ? (
    children
  ) : (
    <Navigate
      to={urlToRedirect}
      replace
    />
  );
